module.exports = flarum.core.compat['forum/components/NotificationsPage'];